// src/router/index.js
import { baseRouter as router } from '@r7e/shared';

router.addRoute(
    {
        path: '/docs/:path(.*)*',
        name: 'Documentation',
        component: () => import('../views/DocumentationView.vue')
    }
)

router.addRoute(
    {
        path: '/',
        name: 'Home',
        component: () => import('../views/HomeView.vue'),
        meta: { requiresAuth: false }
    }
)
router.addRoute(
    {
        path: '/info',
        name: 'PublisherInfo',
        component: () => import('../views/PublisherInfo.vue'),
        meta: { requiresAuth: true }
    }
)
router.addRoute(    
    {
        path: '/transactions',
        name: 'PublisherTransactions',
        component: () => import('../views/PublisherTransactions.vue'),
        meta: { requiresAuth: true }
    }
)
router.addRoute(    
    {
        path: '/receipts',
        name: 'PublisherReceipts',
        component: () => import('../views/PublisherReceipts.vue'),
        meta: { requiresAuth: true }
    }
)
router.addRoute(    
    {
        path: '/receipts/:receiptId',
        name: 'PublisherReceiptView',
        component: () => import('../views/PublisherReceiptView.vue'),
        meta: { requiresAuth: true }
    }
)
router.addRoute(    
    {
        path: '/contents',
        name: 'PublisherContentList',
        component: () => import('../views/PublisherContentList.vue'),
        meta: { requiresAuth: true }
    }
)
router.addRoute(    
    {
        path: '/contents/new',
        name: 'NewContent',
        component: () => import('../views/NewContentView.vue'),
        meta: { requiresAuth: true }
    }
)
router.addRoute(    
    {
        path: '/recognyze-content',
        name: 'RecognyzeContent',
        component: () => import('../views/RecognyzeContent.vue'),
        meta: { requiresAuth: true }
    }
)
router.addRoute(    
    {
      path: '/content/:identifier',
      name: 'PublisherContent',
      component: () => import('../views/ContentForOwner.vue'),
      meta: { requiresAuth: true }
    }
)
router.addRoute(    
    {
      path: '/store/content/:identifier',
      name: 'PublicContent',
      component: () => import('../views/ContentForPublic.vue'),
      meta: { requiresAuth: false }
    }
)
router.addRoute(    
    {
      path: '/edit-content/:identifier',
      name: 'EditContent',
      component: () => import('../views/RecognyzeContent.vue'),
      meta: { requiresAuth: true }
  }
)
router.addRoute(  
    {
        path: '/reports/',
        name: 'Reports',
        component: () => import('../views/ReportsView.vue'),
        meta: { requiresAuth: true }
    }
  )
router.addRoute(    
    {
        path: '/logs/:year?/:month?/:day?',
        name: 'PublisherLogs',
        component: () => import('../views/LogsView.vue'),
        meta: { requiresAuth: true }
    }
)
  router.addRoute(  
    {
        path: '/reports/:start_date/:end_date/:tab?',
        name: 'ReportByRange',
        component: () => import('../views/ReportsView.vue'),
        meta: { requiresAuth: true }
    }
  )  

router.addRoute(
    {
        path: '/website-discovery',
        name: 'PublisherWebsiteDiscovery',
        component: () => import('../views/PublisherWebsiteDiscovery.vue'),
        meta: { requiresAuth: true }
    }
  )

router.addRoute(  
    {
        path: '/actions/author-claim-request/:identifier', 
        name: 'AuthorClaimRequest',
        component: () => import('../views/AuthorClaimRequest.vue'),
        meta: { requiresAuth: true }
    }
)
router.addRoute(  
    {
        path: '/claims/:identifier', 
        name: 'AuthorClaimRequestView',
        component: () => import('../views/AuthorClaimRequest.vue'),
        meta: { requiresAuth: true }
    }
)

router.addRoute(  
    {
        path: '/claims',
        name: 'PublisherClaims',
        component: () => import('../views/PublisherClaimsList.vue'),
        meta: { requiresAuth: true }
    }
)

// router.addRoute(    
//     {
//         path: '/settings', 
//         name: 'Settings',
//         component: () => import('../views/PublisherSettingsView.vue'),
//         meta: { requiresAuth: true }
//     }
// )


export {router};
export default router;